export default __webpack_public_path__ + "static/elevator_sound-6408131a36d8f1cdf6c24814e8618d97.png";